import { Link } from "react-router-dom"
import { servicesObjects } from "./Services"


export const Subscribe = () => {
  return (
    <form action="forms/newsletter.php" method="post" className="php-email-form justify-content-center">
      <div className="newsletter-form"><input type="email" name="email" />
      <input type="submit" value="Subscribe"/></div>
      <div className="loading">Loading</div>
      <div className="error-message"></div>
      <div className="sent-message">Hooooray!!! your subscription was successful!</div>
    </form>
  )
}

const Footer = () => {
  const footerLinks1 = ["Home", "About", "Services", "Terms of Service"]
    return(
      <footer id="footer" className="footer light-background">

      <div className="container footer-top">
        <div className="row gy-4">
          <div className="col-lg-4 col-md-6 footer-about">
            <a href="index.html" className="logo d-flex align-items-center">
              <span className="sitename">Hotelace</span>
            </a>
            <div className="footer-contact pt-3">
              <p>Location road, Obigbo</p>
              <p>Rivers State, 452110</p>
              <p className="mt-3"><strong>Phone:</strong> <span>+234 905 695 6654</span></p>
              <p><strong>Email:</strong> <span>info@crowfran.tech</span></p>
            </div>
            <div className="social-links d-flex mt-4">
              <a href=""><i className="bi bi-twitter-x"></i></a>
              <a href=""><i className="bi bi-facebook"></i></a>
              <a href=""><i className="bi bi-instagram"></i></a>
              <a href=""><i className="bi bi-linkedin"></i></a>
            </div>
          </div>
  
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Useful Links</h4>
            <ul>
              <li><a href="#">Home</a></li>
              <li><a href="#">About us</a></li>
              <li><a href="#">Services</a></li>
              <li><a href="#">Terms of service</a></li>
              <li><a href="#">Privacy policy</a></li>
            </ul>
          </div>
  
          <div className="col-lg-2 col-md-3 footer-links">
            <h4>Our Services</h4>
            <ul>
                {
                  Object.keys(servicesObjects).map(lst => (
                    <li key={lst}><i className="bi bi-chevron-right"></i> <Link to="#">{lst}</Link></li>
                  ))
                }
              </ul>
          </div>
  
          <div className="col-lg-4 col-md-12 footer-newsletter">
            <h4>Book a session with us</h4>
            <p>Get Hotelace Demos!</p>
            <form action="forms/newsletter.php" method="post" className="php-email-form">
              <div className="newsletter-form">
                <input type="email" name="email" />
                <input type="submit" value="Subscribe"/>
              </div>
              <div className="loading">Loading</div>
              <div className="error-message"></div>
              <div className="sent-message">Your subscription request has been sent. Thank you!</div>
            </form>
          </div>
  
        </div>
      </div>
  
      <div className="container copyright text-center mt-4">
        <p>© <span>2024-{new Date().getFullYear()}</span> <strong className="px-1 sitename">CrowFran Innovations Limited</strong> <span>All Rights Reserved</span></p>
        <div className="credits">
   
          <a href="https://crowfran.tech">CrowFran Innovations</a>
        </div>
      </div>
  
    </footer>
    )
}


export default Footer